module.exports = __webpack_public_path__ + "static/img/product2.2ebae00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/product2.png
// module id = PcWR
// module chunks = 0